export default "__VITE_ASSET__Cis41smY__"